export const arrondir=(valeur)=>{
    var val = Number.isNaN(valeur)?parseInt(valeur):valeur;

    if(val>=100){
        val = Math.round(val)
    }
    else if(val>=10){
        val = Math.round(val*10)/10;
    }
    else{
        val = Math.round(val*100)/100;
    }

    return val;
}

export const rgbToHex = function (rgb) {
    var hex = Number(rgb).toString(16);
    if (hex.length < 2) {
        hex = "0" + hex;
    }
    return hex;
};